import '../../Styles/Courtesy.css'

function CourtesyPage(props) {
  return (
    <div className='courtesy'>
      <img className='logo' src='/atelier_logo.png' alt='Atelier' />
    </div>
  )
}

export default CourtesyPage
